import { Box, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import usePermissionType from "../../scenes/permissions/UserPermissionsReview/components/usePermissionType";

const AdminTypeOption = ({ adminType, category }) => {
  const colors = useColors();
  const getPermissionType = usePermissionType();

  const { icon: Icon } = getPermissionType(adminType, category);

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      alignContent={"baseline"}
      gap={1}
    >
      {Icon && <Icon style={{ marginRight: "4px" }} />}
      <Typography variant="caption" color={colors.text_primary}>
        {adminType}
      </Typography>
    </Box>
  );
};

export default AdminTypeOption;
